// Plain data (no React) so src/lib/structuredData.js can build the FAQPage
// schema from the same questions the accordion renders without pulling this
// lazily loaded page into the main bundle.
export const FAQS = [
  {
    question: "Can I really write emails without typing?",
    answer:
      "Yes. With a dictation tool that works inside your email client, you can speak a full message, clean it up with AI, and send it without touching the keyboard except to review.",
  },
  {
    question: "Is voice dictation for email accurate enough for work?",
    answer:
      "Modern AI dictation is accurate enough for professional use, especially when you add names and terms to a custom dictionary and do a quick review before sending.",
  },
  {
    question: "Does hands free email writing work in Gmail?",
    answer:
      "Yes. Zero Typing AI works across apps, including Gmail, so you can dictate directly into the message body.",
  },
  {
    question: "Do I have to say punctuation out loud?",
    answer:
      "No. AI dictation adds punctuation automatically, so you can speak naturally.",
  },
  {
    question: "Is there a free way to try it?",
    answer:
      "Yes. The ZT Basic plan is free and includes 15 minutes of audio transcription per week.",
  },
  {
    question: "What if I need my exact words, not a cleaned-up version?",
    answer:
      "Use the Transcript Only option to keep your words exactly as spoken.",
  },
];
